/** Plano Inteligente: el sistema dibuja la geometría estructurada propuesta por la IA
 *  como SVG vectorial editable (elevación frontal para cotización, NO de fabricación).
 *  Editar un panel solo redibuja ese vector — nunca se regenera con IA al editar. */

const fmtM = (v) => (v == null ? '? m' : `${v} m`);

export const PlanoSVG = ({ plano, selPanel, onSelectPanel, herramienta = 'seleccionar' }) => {
  const paneles = plano?.paneles || [];
  let x = 0;
  const items = paneles.map((p) => {
    const w = p.ancho_m || 0.8, h = p.alto_m || 2.0;
    const it = { ...p, _x: x, _w: w, _h: h };
    x += w;
    return it;
  });
  const totalW = Math.max(x, 0.6);
  const maxH = Math.max(1, ...items.map((i) => i._h));
  const M = 0.55;
  const fs = Math.max(totalW, maxH) * 0.05;
  const tick = fs * 0.5;
  return (
    <svg viewBox={`${-M} ${-fs * 3.4} ${totalW + 2 * M} ${maxH + fs * 3.4 + fs * 5}`} width="100%"
      style={{ display: 'block', background: '#FFFFFF', borderRadius: 10 }} data-testid="plano-svg">
      <line x1={-M * 0.7} y1={maxH} x2={totalW + M * 0.7} y2={maxH} stroke="#B9A5D9" strokeWidth={fs * 0.14} />
      {items.map((p, i) => {
        const sel = selPanel === p.id;
        const pend = p.medida_estado !== 'confirmada' || p.ancho_m == null || p.alto_m == null;
        const y0 = maxH - p._h;
        const izq = p.bisagras !== 'derecha';
        return (
          <g key={p.id}
            onPointerDown={(e) => { if (herramienta === 'agregar') return; e.stopPropagation(); }}
            onClick={(e) => { if (herramienta === 'agregar') return; e.stopPropagation(); onSelectPanel?.(p.id); }}
            style={{ cursor: 'pointer' }} data-testid={`plano-panel-${p.id}`}>
            {p.tipo === 'division' ? (
              <line x1={p._x + p._w / 2} y1={y0} x2={p._x + p._w / 2} y2={maxH} stroke="#38205F" strokeWidth={fs * 0.35} />
            ) : (
              <rect x={p._x + 0.015} y={y0} width={Math.max(p._w - 0.03, 0.05)} height={p._h}
                fill="#7EB6E8" fillOpacity={0.3} stroke={sel ? '#D5AD65' : '#38205F'}
                strokeWidth={sel ? fs * 0.24 : fs * 0.1} strokeDasharray={pend ? `${fs * 0.8} ${fs * 0.5}` : ''} />
            )}
            {p.tipo === 'puerta' && (
              <g pointerEvents="none">
                <circle cx={izq ? p._x + 0.05 : p._x + p._w - 0.05} cy={y0 + p._h * 0.18} r={fs * 0.4} fill="#38205F" />
                <circle cx={izq ? p._x + 0.05 : p._x + p._w - 0.05} cy={y0 + p._h * 0.82} r={fs * 0.4} fill="#38205F" />
                <line x1={izq ? p._x + p._w - 0.09 : p._x + 0.09} y1={y0 + p._h * 0.44}
                  x2={izq ? p._x + p._w - 0.09 : p._x + 0.09} y2={y0 + p._h * 0.58}
                  stroke="#38205F" strokeWidth={fs * 0.22} strokeLinecap="round" />
                <path d={`M ${izq ? p._x : p._x + p._w} ${y0} L ${izq ? p._x + p._w : p._x} ${y0 + p._h / 2} L ${izq ? p._x : p._x + p._w} ${y0 + p._h}`}
                  fill="none" stroke="#38205F" strokeWidth={fs * 0.06} strokeDasharray={`${fs * 0.5} ${fs * 0.4}`} opacity={0.65} />
              </g>
            )}
            {i > 0 && Number(p.angulo_con_anterior) === 90 && (
              <g pointerEvents="none">
                <line x1={p._x} y1={y0 - fs} x2={p._x} y2={maxH + fs * 0.6} stroke="#D5AD65" strokeWidth={fs * 0.16} />
                <text x={p._x} y={y0 - fs * 1.5} fontSize={fs} fill="#B8863B" textAnchor="middle" fontWeight="700">∠90°</text>
              </g>
            )}
            <text x={p._x + p._w / 2} y={y0 - fs * 0.5} fontSize={fs} fill="#38205F" textAnchor="middle" fontWeight="800" pointerEvents="none">
              {`P${i + 1} · ${p.tipo}`}
            </text>
            {(p.alto_m == null || (items[0] && p.alto_m !== items[0].alto_m)) && p.tipo !== 'division' && (
              <text x={p._x + p._w / 2} y={y0 + p._h / 2} fontSize={fs * 0.9} fill={p.alto_m == null ? '#B45309' : '#6B6B6B'} textAnchor="middle" fontWeight="600" pointerEvents="none">
                {`h: ${fmtM(p.alto_m)}`}
              </text>
            )}
            <g pointerEvents="none">
              <line x1={p._x + 0.02} y1={maxH + fs * 1.6} x2={p._x + p._w - 0.02} y2={maxH + fs * 1.6}
                stroke={pend && p.ancho_m == null ? '#F59E0B' : '#38205F'} strokeWidth={fs * 0.07} />
              <line x1={p._x + 0.02} y1={maxH + fs * 1.6 - tick} x2={p._x + 0.02} y2={maxH + fs * 1.6 + tick} stroke="#38205F" strokeWidth={fs * 0.07} />
              <line x1={p._x + p._w - 0.02} y1={maxH + fs * 1.6 - tick} x2={p._x + p._w - 0.02} y2={maxH + fs * 1.6 + tick} stroke="#38205F" strokeWidth={fs * 0.07} />
              <text x={p._x + p._w / 2} y={maxH + fs * 3.1} fontSize={fs} textAnchor="middle" fontWeight="700"
                fill={p.ancho_m == null ? '#B45309' : '#1F1B29'}>{fmtM(p.ancho_m)}</text>
            </g>
          </g>
        );
      })}
      <g pointerEvents="none">
        <line x1={-M * 0.55} y1={maxH - (items[0]?._h || maxH)} x2={-M * 0.55} y2={maxH} stroke={items[0]?.alto_m == null ? '#F59E0B' : '#38205F'} strokeWidth={fs * 0.07} />
        <text x={-M * 0.55 - fs * 0.6} y={maxH - (items[0]?._h || maxH) / 2} fontSize={fs} textAnchor="middle" fontWeight="700"
          fill={items[0]?.alto_m == null ? '#B45309' : '#1F1B29'}
          transform={`rotate(-90 ${-M * 0.55 - fs * 0.6} ${maxH - (items[0]?._h || maxH) / 2})`}>{fmtM(items[0]?.alto_m)}</text>
      </g>
    </svg>
  );
};

export const PanelEditor = ({ plano, panelId, onChange, onCerrar }) => {
  const i = (plano.paneles || []).findIndex((p) => p.id === panelId);
  const p = plano.paneles?.[i];
  if (!p) return null;
  const upd = (patch) => onChange({ ...plano, paneles: plano.paneles.map((q) => (q.id === panelId ? { ...q, ...patch } : q)) });
  const medida = (campo, txt) => {
    const v = parseFloat(String(txt).replace(',', '.'));
    const patch = { [campo]: isNaN(v) || v <= 0 ? null : v };
    const o = { ...p, ...patch };
    patch.medida_estado = o.ancho_m != null && o.alto_m != null ? 'confirmada' : 'pendiente';
    upd(patch);
  };
  const mover = (dir) => {
    const arr = [...plano.paneles];
    const j = i + dir;
    if (j < 0 || j >= arr.length) return;
    [arr[i], arr[j]] = [arr[j], arr[i]];
    onChange({ ...plano, paneles: arr });
  };
  const agregar = () => {
    const id = 'p' + Math.random().toString(36).slice(2, 7);
    onChange({ ...plano, paneles: [...plano.paneles.slice(0, i + 1), { id, tipo: 'fijo', ancho_m: null, alto_m: p.alto_m ?? null, medida_estado: 'pendiente', angulo_con_anterior: 180 }, ...plano.paneles.slice(i + 1)] });
  };
  const eliminar = () => { onChange({ ...plano, paneles: plano.paneles.filter((q) => q.id !== panelId) }); onCerrar(); };
  const chip = (act) => `text-[10px] font-black px-2.5 py-1.5 rounded-full border ${act ? 'bg-[#7352B5] text-white border-[#7352B5]' : 'bg-white text-[#38205F] border-[#B9A5D9]/70'}`;
  return (
    <div className="space-y-2" data-testid="plano-panel-editor">
      <div className="flex items-center justify-between">
        <p className="text-[12px] font-black text-[#38205F]">📐 Panel P{i + 1} · {p.tipo} {p.medida_estado !== 'confirmada' && <span className="text-amber-600">· ⚠ medidas pendientes</span>}</p>
        <button onClick={onCerrar} className="text-[#6B6B6B] font-black px-2 py-1" data-testid="plano-panel-cerrar">✕</button>
      </div>
      <div className="flex gap-1.5 flex-wrap">
        {['fijo', 'puerta', 'division'].map((t) => (
          <button key={t} onClick={() => upd({ tipo: t })} className={chip(p.tipo === t)} data-testid={`plano-tipo-${t}`}>
            {t === 'fijo' ? '🪟 Fijo' : t === 'puerta' ? '🚪 Puerta' : '│ División'}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-2 gap-2">
        <label className="text-[10px] font-bold text-[#6B6B6B]">Ancho (m)
          <input type="text" inputMode="decimal" defaultValue={p.ancho_m ?? ''} key={`a${panelId}-${p.ancho_m ?? 'n'}`} placeholder="? pendiente"
            onBlur={(e) => medida('ancho_m', e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && medida('ancho_m', e.target.value)}
            className="w-full h-10 px-2.5 text-sm rounded-lg border border-[#B9A5D9]/60 outline-none focus:border-[#7352B5] mt-0.5" data-testid="plano-ancho" />
        </label>
        <label className="text-[10px] font-bold text-[#6B6B6B]">Alto (m)
          <input type="text" inputMode="decimal" defaultValue={p.alto_m ?? ''} key={`h${panelId}-${p.alto_m ?? 'n'}`} placeholder="? pendiente"
            onBlur={(e) => medida('alto_m', e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && medida('alto_m', e.target.value)}
            className="w-full h-10 px-2.5 text-sm rounded-lg border border-[#B9A5D9]/60 outline-none focus:border-[#7352B5] mt-0.5" data-testid="plano-alto" />
        </label>
      </div>
      {p.tipo === 'puerta' && (
        <div className="flex gap-1.5 items-center">
          <span className="text-[10px] font-bold text-[#6B6B6B]">Bisagras:</span>
          {['izquierda', 'derecha'].map((l) => (
            <button key={l} onClick={() => upd({ bisagras: l })} className={chip((p.bisagras || 'izquierda') === l)} data-testid={`plano-bisagras-${l}`}>{l}</button>
          ))}
        </div>
      )}
      {i > 0 && (
        <div className="flex gap-1.5 items-center">
          <span className="text-[10px] font-bold text-[#6B6B6B]">Ángulo con el anterior:</span>
          {[180, 90].map((a) => (
            <button key={a} onClick={() => upd({ angulo_con_anterior: a })} className={chip(Number(p.angulo_con_anterior || 180) === a)} data-testid={`plano-angulo-${a}`}>{a === 90 ? '∠ 90° esquina' : '— recto'}</button>
          ))}
        </div>
      )}
      <div className="flex gap-1.5 flex-wrap pt-0.5">
        <button onClick={() => mover(-1)} disabled={i === 0} className={`${chip(false)} disabled:opacity-40`} data-testid="plano-mover-izq">◀ Mover</button>
        <button onClick={() => mover(1)} disabled={i === plano.paneles.length - 1} className={`${chip(false)} disabled:opacity-40`} data-testid="plano-mover-der">Mover ▶</button>
        <button onClick={agregar} className={chip(false)} data-testid="plano-agregar-panel">➕ Panel</button>
        <button onClick={eliminar} className="text-[10px] font-black px-2.5 py-1.5 rounded-full border border-red-300 text-red-500 bg-white" data-testid="plano-eliminar-panel">🗑 Eliminar</button>
      </div>
      <p className="text-[9px] text-[#6B6B6B]">Los cambios solo redibujan el plano (deshacer disponible). No afectan productos ya confirmados.</p>
    </div>
  );
};
